import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  feedbackDialog: {
    width: 652,
    height: 725,
  },
  progress: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  fileList: {
    width: 300,
  },
  progressBar: {
    width: 200,
  },
  removeButton: {
    opacity: 0,
    '&:hover': {
      opacity: 1,
    },
  },
}));
